import React from 'react';
import TylerTechIntegration from '@/components/admin/TylerTechIntegration';

export default function TylerTechIntegrationPage() {
  return <TylerTechIntegration />;
}